<template>
    <full-screen-overlay @close="exit" backTo="Models">
        <dashboard-header header="Create new model" description="Lorem ipsum dolor sit, amet consectetur adipisicing elitum..."/>

        <div class="w-full mt-8">
            <FormulateForm @submit="createModel" class="max-w-screen-xs" :values="model">
                <label class="text-sm text-gray-500 leading-8" for="name">Model name...</label>
                <base-input autofocus required placeholder="Type name of model..." id="name" name="name" class="mb-6" />

                <label class="text-sm text-gray-500 leading-8" for="tier">Model tier...</label>
                <base-select
                    id="tier"
                    name="tier"
                    :options="{ small: 'Small', medium: 'Medium', large: 'Large' }"
                    type="select"
                    placeholder="Select an option"
                />

                <label class="text-sm text-gray-500 leading-8" for="parallelisation">Parallelisation tier...</label>
                <base-select
                    id="parallelisation"
                    name="parallelisation"
                    :options="{ none: 'None', light: 'Light', max: 'Max' }"
                    type="select"
                    placeholder="Select an option"
                />

                <label class="text-sm text-gray-500 leading-8" for="region">Region...</label>
                <base-select
                    id="region"
                    name="region"
                    :options="{ westus: 'West US', australia: 'Australia' }"
                    type="select"
                    placeholder="Select an option"
                />

                <base-button bgColor="bg-success dark:bg-green-600" borderColor="border-success" hoverBg="hover:bg-green-400 dark-hover:bg-green-500" hoverBorder="hover:border-success-400" class="mt-10" icon="model" iconPosition="left"  type="submit">Create Model</base-button>
            </FormulateForm>
        </div>

    </full-screen-overlay>
</template>

<script>
import { LayoutComponents } from '@/modules/Dashboard/components'
import { createModel } from "@/graphql/mutations";
import { uploadModelImage } from "@/graphql/queries";
import { authenticationState, currentProject, loading, error } from '@/mixins';
import { BlockBlobClient } from "@azure/storage-blob";

export default {
    name: "CreateModel",
    metaInfo: {
      title: 'New Model',
    },
    mixins: [LayoutComponents, authenticationState, currentProject, loading, error ],
    data () {
        return {
            isSubmitting: false,
            model: {
                name: '',
                tier: 'small',
                parallelisation: 'none',
                region: 'westus'
            }
        }
    },
    methods: {
        exit (modelId) {

            if (modelId) {
                return this.$router.push({ name: 'ModelPage', params: { modelId }, query: { ...this.$route.query } });
            }

            return this.$router.push({ name: 'Models' });

        },
        async createModel(data) {

            if (this.isSubmitting) {
                return
            }

            this.isSubmitting = true;

            try {
                this.$root.$emit('loading', true);

            let ram = 1;

            switch (data.tier) {
                case 'small':
                    ram = 1;
                    break;
                case 'medium':
                    ram = 2;
                    break;
                case 'large':
                    ram = 4;
                    break;
            }

            let cpu = 1;

            switch (data.parallelisation) {
                case 'none':
                    cpu = 1;
                    break;
                case 'light':
                    cpu = 2;
                    break;
                case 'max':
                    cpu = 4;
                    break;
            }

            const model = await this.$apollo.mutate({
                mutation: createModel,
                variables: {
                    input: {
                        projectId: this.authenticationState.selectedProject,
                        name: data.name,
                        ram,
                        cpu,
                        region: data.region
                    }
                }
            });

                this.exit(model.data.createModel.model.id);
            } catch (error) {
                this.handleError(error);
            }

            this.$root.$emit('loading', false);

            this.isSubmitting = false;
        },
    }
}
</script>